<script>
    import { Doughnut } from './Chart';

    export default {
        extends: Doughnut,
        props:{
            value: {
                type: Object,
                required: false
            }         
        },
        watch:{
            value(newValue){
                let dataset = [];
                if(newValue != null) 
                    dataset = newValue;

                this.renderChart(dataset);
            }
        },        
        mounted () {
            let dataset = [];
            if(this.value != null) 
                dataset = this.value;

            this.renderChart(dataset);
        }
    }
</script>